import { useWorkspaceDetails } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";

export function useActiveWorkspaceDetails() {
    const { workspaceId } = useScope();

    const { data: workspace } = useWorkspaceDetails(workspaceId);

    return workspace;
}
